import { FETCH_ALL_COUNTRIES_FOR_VOLUNTEERS } from '../../constants/actionTypes'

export default (countriesForVolunteers = [], action) => {
    switch (action.type) {
        case FETCH_ALL_COUNTRIES_FOR_VOLUNTEERS:
            return action.payload;
        default:
            return countriesForVolunteers;
    }
}